module.exports = __webpack_public_path__ + "img/watch-blue.95960a06.png";